import type CK from '~/types/contentking';

import {
	useWebsiteIsCrawlingPausedQuery,
} from './useWebsiteIsCrawlingPaused.gql';

import useBatchContextWebsiteConfiguration from '~/hooks/useBatchContextWebsiteConfiguration';



function useWebsiteIsCrawlingPaused(websiteId: CK.WebsiteId | null): boolean | null {
	const { data } = useWebsiteIsCrawlingPausedQuery({
		context: useBatchContextWebsiteConfiguration(websiteId),
		skip: websiteId === null,
		variables: {
			websiteId: websiteId ?? '',
		},
	});

	return (data?.website?.isCrawlingPaused) ?? null;
}



export default useWebsiteIsCrawlingPaused;
